import {useEffect, useRef, useState} from 'react'
// Styles
import {MAX_UPLOAD_FILE_SIZE_BYTES} from '../../consts/uploads'
import formStyles from './forms.module.scss'
// @ts-ignore — uploadcare types require moduleResolution 'bundler'
import * as UC from '@uploadcare/file-uploader'

interface InputImageuploadProps {
  id: string
  label: string
  instructions?: React.ReactNode
  errorMessage?: string | null
  isRequired?: boolean
  // isDisabled?: boolean
  onChange: (cdnUrl: string, id: string) => void
}

const InputImageupload = ({
  id,
  label,
  instructions,
  errorMessage = null,
  isRequired = false,
  // isDisabled = false,
  onChange,
}: InputImageuploadProps) => {
  // TODO: Come up with a better UX for required image upload
  UC.defineComponents(UC)
  const ctxProviderRef = useRef<any>(null)
  const configRef = useRef<any>(null)

  useEffect(() => {
    if (ctxProviderRef.current) {
      ctxProviderRef.current.addEventListener('file-upload-success', (e: any) => {
        const file = e.detail
        onChange(file.cdnUrl, id)
      })
    }
  }, [onChange])

  const [isClient, setIsClient] = useState(false)
  useEffect(() => {
    setIsClient(true)
  }, [])

  useEffect(() => {
    if (isClient && configRef?.current) {
      const config = configRef.current
      config.localeDefinitionOverride = {
        en: {
          'upload-file': 'Choose documents',
          'choose-file': `Upload photo${isRequired ? ' (required)' : ''}`,
          'choose-files': 'Upload photo(s)',
        },
      }
    }
  }, [isClient, configRef])

  // TODO: Make label disappear after image is removed from uploader
  return (
    <div
      key={id}
      className={formStyles['__imageupload-wrapper']}
    >
      <label className={formStyles['__label']}>{label}</label>
      <uc-config
        ref={configRef}
        ctx-name={id}
        pubkey={process.env.NEXT_PUBLIC_UPLOADCARE_KEY}
        img-only={true}
        multiple={false}
        max-local-file-size-bytes={MAX_UPLOAD_FILE_SIZE_BYTES}
        remove-copyright={true}
        draggable={false}
      ></uc-config>

      <uc-file-uploader-minimal
        ctx-name={id}
        class='uc-light additional-field-uploader'
      ></uc-file-uploader-minimal>

      <uc-upload-ctx-provider
        ref={ctxProviderRef}
        ctx-name={id}
      ></uc-upload-ctx-provider>
      {errorMessage && (
        <span className={formStyles['__error-message']}>
          {errorMessage}
        </span>
      )}
      <div className={formStyles['__instructions']}>{instructions}</div>
    </div>
  )
}

export default InputImageupload
